<div
  class="pp-drop-zone"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)">
  <span
    *ngIf="chip"
    class="pp-drop-zone__chip"
    [class.pp-drop-zone__chip--staff]="chipTone === 'staff'"
    [class.pp-drop-zone__chip--office]="chipTone === 'office'">
    {{ chip }}
  </span>
  <div class="pp-drop-zone__icon" *ngIf="showIcon && !loading" aria-hidden="true">
    <i class="pi pi-upload"></i>
  </div>
  <div class="pp-drop-zone__icon" *ngIf="loading" aria-hidden="true">
    <i class="pi pi-spin pi-spinner"></i>
  </div>
  <p class="pp-drop-zone__hint">{{ loading ? 'Uploading…' : hint }}</p>
  <label class="pp-drop-zone__btn">
    <input
      type="file"
      class="pp-drop-zone__input"
      [attr.multiple]="multiple ? '' : null"
      [accept]="accept.join(',')"
      [disabled]="disabled || loading"
      (change)="onFileInput($event)" />
    <i class="pi pi-paperclip" aria-hidden="true"></i>
    {{ loading ? 'Uploading…' : label }}
  </label>
  <p class="pp-drop-zone__accept" *ngIf="acceptHint">{{ acceptHint }}</p>
</div>
